export default {
	setString(state, payload) {
		state.string = payload;
	},

	setHeader(state, payload) {
		state.header = payload;
		axios.defaults.headers[payload.name] = payload.value;
	},

	setUsers(state, payload) {
		state.users = payload;
	}
};
